import React, { useEffect, useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { Modal } from "antd";
import logo from "../../utilities/logo.png";
import { BiUser } from "react-icons/bi";
import { TbLayoutDashboard } from "react-icons/tb";
import { GrAnnounce } from "react-icons/gr";
import { SlCalender } from "react-icons/sl";
import { LuPartyPopper } from "react-icons/lu";
import { MdOutlineAssignment } from "react-icons/md";
import { IoLinkSharp, IoLogOutOutline } from "react-icons/io5";
import { FiFolderPlus } from "react-icons/fi";
import { VscTarget } from "react-icons/vsc";
import { FaRegShareFromSquare } from "react-icons/fa6";
import { PiAddressBook } from "react-icons/pi";
import { MdOutlinePreview } from "react-icons/md";
import { AiOutlineGift } from "react-icons/ai";
import { API_URL } from "../../environment";
import { notification } from "antd";
import { LiaUserSolid } from "react-icons/lia";
import { GoLock } from "react-icons/go";
import { useSelector } from "react-redux";
import { BsClipboardCheck } from "react-icons/bs";
import { RiFileInfoLine } from "react-icons/ri";
import ApiClient from "../../methods/api/apiClient";
import Chatbot from "../../pages/Chat/Chatbot";
const styles = {
  fontWeight: "bold",
  color: "#535356",
};

const SideBar = ({ active, setActive }) => {
  let tl = localStorage.getItem("tl");

  const [isActive, setIsActive] = useState(false);
  const [checkinTime, setCheckinTime] = useState([]);
  const role = localStorage.getItem("role");
  const USERID = localStorage.getItem("USERID");
  console.log(USERID);

  const [countData, setCount] = useState({});
  let history = useNavigate();
  let uniqueid = [];
  uniqueid =
    checkinTime &&
    checkinTime.map((fetchid, id) => {
      return fetchid.id;
    });

  const handleLogOut = () => {
    const attId = localStorage.getItem("attId");
    const token = localStorage.getItem("token");
    const PunchIn = localStorage.getItem("PunchIn");
    if (PunchIn == "true") {
      fetch(`${API_URL}attendance/checkout?attendanceId=${attId}`, {
        method: "PUT",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }).then(async (res) => {
        const respose = await res.json();
        if (respose.success == true) {
          notification.success({ message: "PunchOut Successfully!" });
          localStorage.clear();
          history("/");
          notification.success({
            message: "Logout Successfully",
          });
        } else {
          notification.error({
            message: "UnAuthorized",
            description: "Login Again! PunchOut Manually",
          });
          localStorage.clear();
          history("/");
          notification.success({
            message: "Logout Successfully",
          });
        }
      });
    } else {
      history("/");
      notification.success({
        message: "Logout Successfully",
      });
      localStorage.clear();
    }
  };

  useEffect(() => {
    getLeaveStatus();
  }, []);

  const getLeaveStatus = () => {
    ApiClient.allApi(`leaveNotificationCount?id=${USERID ? USERID : ""}`).then(
      (res) => {
        if (res.success) {
          setCount(res);
        }
      }
    );
  };

  return (
    <div>
      {USERID ? <Chatbot /> : ''}
      <div className="sidebars_lists">
        {active == "home" ? (
          role == "subadmin" ? (
            <ul className=" ullistsli">
              <li className="nav-item border-bottom mb-0">
                <NavLink
                  to="/hrdashboard"
                  className={(navData) =>
                    navData.isActive ? "nav-link active_side" : "nav-link"
                  }
                //
                >
                  <TbLayoutDashboard />
                  <span>Dashboard</span>
                </NavLink>
              </li>

              <li className="nav-item border-bottom mb-0 ">
                <NavLink
                  className={(navData) =>
                    navData.isActive ? "nav-link active_side" : "nav-link"
                  }
                  to="/attendance"
                >
                  <SlCalender />
                  <span>Attendance</span>
                </NavLink>
              </li>

              <li className="nav-item border-bottom mb-0 ">
                <NavLink
                  className={(navData) =>
                    navData.isActive ? "nav-link active_side" : "nav-link"
                  }
                  to="/knowledgesharinglist"
                >
                  <FaRegShareFromSquare />
                  <span>Knowledge Sharing</span>
                </NavLink>
              </li>
              <li className="nav-item border-bottom mb-0 ">
                <NavLink
                  className={(navData) =>
                    navData.isActive ? "nav-link active_side" : "nav-link"
                  }
                  to="/leavelist"
                >
                  <BsClipboardCheck />
                  <div className="">
                    {" "}
                    <span>Leaves</span>{" "}
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="100"
                        height="100"
                        viewBox="0 0 50 50"
                      >
                        <path d="M 25 2 C 12.264481 2 2 12.264481 2 25 C 2 37.735519 12.264481 48 25 48 C 37.735519 48 48 37.735519 48 25 C 48 12.264481 37.735519 2 25 2 z M 25 4 C 36.664481 4 46 13.335519 46 25 C 46 36.664481 36.664481 46 25 46 C 13.335519 46 4 36.664481 4 25 C 4 13.335519 13.335519 4 25 4 z M 25 11 A 3 3 0 0 0 25 17 A 3 3 0 0 0 25 11 z M 21 21 L 21 23 L 23 23 L 23 36 L 21 36 L 21 38 L 29 38 L 29 36 L 27 36 L 27 21 L 21 21 z"></path>
                      </svg>
                    </span>{" "}
                  </div>
                </NavLink>
              </li>
              <li className="nav-item border-bottom mb-0 ">
                <NavLink
                  className={(navData) =>
                    navData.isActive ? "nav-link active_side" : "nav-link"
                  }
                  to="/resignation"
                >
                  <PiAddressBook />
                  <span>Resignation</span>
                </NavLink>
              </li>
              <li className="nav-item border-bottom mb-0 ">
                <NavLink
                  className={(navData) =>
                    navData.isActive ? "nav-link active_side" : "nav-link"
                  }
                  to="/appraisal"
                >
                  <AiOutlineGift />

                  <span>Appraisal</span>
                </NavLink>
              </li>
            </ul>
          ) : (
            <ul className="ullistsli ">
              <li className="nav-item border-bottom mb-0  ">
                <NavLink
                  to="/dashboard"
                  className={(navData) =>
                    navData.isActive ? "nav-link active_side" : "nav-link"
                  }
                >
                  <TbLayoutDashboard />

                  <span>Dashboard</span>
                </NavLink>
              </li>
              <li className="nav-item border-bottom mb-0 ">
                <NavLink
                  to="/announcementlist"
                  className={(navData) =>
                    navData.isActive ? "nav-link active_side" : "nav-link"
                  }
                >
                  <GrAnnounce />
                  <span>Announcements</span>
                </NavLink>
              </li>

              <li className="nav-item border-bottom mb-0  ">
                <NavLink
                  to="/holidaylist"
                  className={(navData) =>
                    navData.isActive ? "nav-link active_side" : "nav-link"
                  }
                >
                  <LuPartyPopper />

                  <span>Holidays</span>
                </NavLink>
              </li>

              <li className="nav-item border-bottom mb-0 ">
                <NavLink
                  className={(navData) =>
                    navData.isActive ? "nav-link active_side" : "nav-link"
                  }
                  to="/attendance"
                >
                  <SlCalender />
                  <span>Attendance</span>
                </NavLink>
              </li>

              {/* 
              {tl==='true'? (
                <div>
                  <li className="nav-item border-bottom mb-0 ">
                    <NavLink
                      className={(navData) =>
                        navData.isActive ? "nav-link active_side" : "nav-link"
                      }
                      to="/projectAssign"
                    >
                      <FiFolderPlus />

                      <span> Asign Project</span>
                    </NavLink>
                  </li>
              
                </div>
              ) : (
                <></>
              )} */}
              {/* {tl === 'true' ? (
                <div>
                  <li className="nav-item border-bottom mb-0 ">
                    <NavLink
                      className={(navData) =>
                        navData.isActive ? "nav-link active_side" : "nav-link"
                      }
                      to="/employeeAssigned"
                    >
                      <FiFolderPlus />

                      <span> Asign Project</span>
                    </NavLink>
                  </li>

                </div>
              ) : (
                <></>
              )}

              <li className="nav-item border-bottom mb-0 ">
                <NavLink
                  className={(navData) =>
                    navData.isActive ? "nav-link active_side" : "nav-link"
                  }
                  to="/projectassigntable"
                >
                  <MdOutlineAssignment />

                  <span>Assigned Projects</span>
                </NavLink>
              </li>

              {tl === 'true' ? (
                <div>
                  <li className="nav-item border-bottom mb-0 ">
                    <NavLink
                      className={(navData) =>
                        navData.isActive ? "nav-link active_side" : "nav-link"
                      }
                      to="/allProject"
                    >
                      <FiFolderPlus />

                      <span> Add Project</span>
                    </NavLink>
                  </li>
                  <li className="nav-item border-bottom mb-0 ">
                    <NavLink
                      className={(navData) =>
                        navData.isActive ? "nav-link active_side" : "nav-link"
                      }
                      to="/monthtarget"
                    >
                      <VscTarget />

                      <span>Target</span>
                    </NavLink>
                  </li>
                </div>
              ) : (
                <></>
              )} */}
              {role === "bde" ? (
                <>
                  {" "}
                  <li className="nav-item dropdown border-bottom mb-0">
                    <a
                      href="#homeSubmenuuu"
                      data-bs-toggle="collapse" // <-- Updated for Bootstrap 5
                      aria-expanded="false"
                      className="nav-link dropside d-flex align-items-center"
                    >
                      <RiFileInfoLine />
                      <span>Project Management</span>
                      <i
                        className="fas fa-caret-down ms-auto"
                        aria-hidden="true"
                      ></i>
                    </a>

                    <ul className="collapse list-unstyled" id="homeSubmenuuu">
                      <li className="nav-item border-bottom mb-0">
                        <NavLink
                          className="nav-link bg-content"
                          to="/allProject"
                        >
                          <FiFolderPlus />
                          <span> Add Project</span>
                        </NavLink>
                      </li>
                      <li className="nav-item border-bottom mb-0">
                        <NavLink
                          className="nav-link bg-content"
                          to="/employeeAssigned"
                        >
                          <FiFolderPlus />
                          <span> Assign Project</span>
                        </NavLink>
                      </li>
                      <li className="nav-item border-bottom mb-0">
                        <NavLink
                          className="nav-link bg-content"
                          to="/projectassigntable"
                        >
                          <MdOutlineAssignment />
                          <span>Assigned Projects</span>
                        </NavLink>
                      </li>

                      {/* <li className="nav-item border-bottom mb-0">
                    <NavLink className="nav-link bg-content" to="/monthtarget">
                      <VscTarget />
                      <span>Target</span>
                    </NavLink>
                  </li> */}
                      <li className="nav-item border-bottom mb-0 ">
                        {/* <NavLink
                          className={(navData) =>
                            navData.isActive
                              ? "nav-link active_side"
                              : "nav-link"
                          }
                          to="/reviewprojectlist"
                        > */}

                        <NavLink
                          className="nav-link bg-content"
                          to="/reviewprojectlist"
                        >
                          <MdOutlinePreview />

                          <span>Review Project</span>
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                </>
              ) : (
               <>
               {
                tl === "true" ?
                    <>
                  {" "}
                  <li className="nav-item dropdown border-bottom mb-0">
                    <a
                      href="#homeSubmenuuu"
                      data-bs-toggle="collapse" // <-- Updated for Bootstrap 5
                      aria-expanded="false"
                      className="nav-link dropside d-flex align-items-center"
                    >
                      <RiFileInfoLine />
                      <span>Project Management</span>
                      <i
                        className="fas fa-caret-down ms-auto"
                        aria-hidden="true"
                      ></i>
                    </a>

                    <ul className="collapse list-unstyled" id="homeSubmenuuu">
                      {/* <li className="nav-item border-bottom mb-0">
                        <NavLink
                          className="nav-link bg-content"
                          to="/allProject"
                        >
                          <FiFolderPlus />
                          <span> Add Project</span>
                        </NavLink>
                      </li> */}
                      <li className="nav-item border-bottom mb-0">
                        <NavLink
                          className="nav-link bg-content"
                          to="/employeeAssigned"
                        >
                          <FiFolderPlus />
                          <span> Assign Project</span>
                        </NavLink>
                      </li>
                      <li className="nav-item border-bottom mb-0">
                        <NavLink
                          className="nav-link bg-content"
                          to="/projectassigntable"
                        >
                          <MdOutlineAssignment />
                          <span>Assigned Projects</span>
                        </NavLink>
                      </li>         
                      <li className="nav-item border-bottom mb-0 ">
                        <NavLink
                          className="nav-link bg-content"
                          to="/reviewprojectlist"
                        >
                          <MdOutlinePreview />

                          <span>Review Project</span>
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                </>
                :
                ""
               }
               </>
              )}


              {tl === "false" && role !== "bde" ? (
                <>
                  {" "}
                  <li className="nav-item dropdown border-bottom mb-0">
                    <a
                      href="#homeSubmenuuu"
                      data-bs-toggle="collapse" // <-- Updated for Bootstrap 5
                      aria-expanded="false"
                      className="nav-link dropside d-flex align-items-center"
                    >
                      <RiFileInfoLine />
                      <span>Project Management</span>
                      <i
                        className="fas fa-caret-down ms-auto"
                        aria-hidden="true"
                      ></i>
                    </a>

                    <ul className="collapse list-unstyled" id="homeSubmenuuu">
                      <li className="nav-item border-bottom mb-0">
                        <NavLink
                          className="nav-link bg-content"
                          to="/projectassigntable"
                        >
                          <MdOutlineAssignment />
                          <span>Assigned Projects</span>
                        </NavLink>
                      </li>

                      {/* <li className="nav-item border-bottom mb-0">
                    <NavLink className="nav-link bg-content" to="/monthtarget">
                      <VscTarget />
                      <span>Target</span>
                    </NavLink>
                  </li> */}
                      <li className="nav-item border-bottom mb-0 ">
                        {/* <NavLink
                          className={(navData) =>
                            navData.isActive
                              ? "nav-link active_side"
                              : "nav-link"
                          }
                          to="/reviewprojectlist"
                        > */}

                        <NavLink
                          className="nav-link bg-content"
                          to="/reviewprojectlist"
                        >
                          <MdOutlinePreview />

                          <span>Review Project</span>
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                </>
              ) : (
                ""
              )}

              <li className="nav-item border-bottom mb-0 ">
                <NavLink
                  className={(navData) =>
                    navData.isActive ? "nav-link active_side" : "nav-link"
                  }
                  to="/knowledgesharinglist"
                >
                  <FaRegShareFromSquare />

                  <span>Knowledge Sharing</span>
                </NavLink>
              </li>
              <li className="nav-item border-bottom mb-0 ">
                <NavLink
                  className={(navData) =>
                    navData.isActive ? "nav-link active_side" : "nav-link"
                  }
                  to="/leavelist"
                >
                  <BsClipboardCheck />
                  <div className="d-flex justify-content-between align-items-center w-100">
                    {" "}
                    <span>Leaves</span>
                  </div>
                </NavLink>
              </li>
              {tl === "true" ? (
                <li className="nav-item border-bottom mb-0 ">
                  <NavLink
                    className={(navData) =>
                      navData.isActive ? "nav-link active_side" : "nav-link"
                    }
                    to="/requestedleavelist"
                  >
                    <RiFileInfoLine />
                    <div className="d-flex justify-content-between align-items-center w-100">
                      {" "}
                      <span>Requested Leaves </span>
                      {countData?.count > 0 ? (
                        <>
                          <div class="info-circle m-0"></div>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </NavLink>
                </li>
              ) : (
                ""
              )}
              <li className="nav-item border-bottom mb-0 ">
                <NavLink
                  className={(navData) =>
                    navData.isActive ? "nav-link active_side" : "nav-link"
                  }
                  to="/resignation"
                >
                  <PiAddressBook />

                  <span>Resignation</span>
                </NavLink>
              </li>
              {/* {tl === "true" ? (
                <li className="nav-item border-bottom mb-0 ">
                  <NavLink
                    className={(navData) =>
                      navData.isActive ? "nav-link active_side" : "nav-link"
                    }
                    to="/reviewprojectlist"
                  >
                    <MdOutlinePreview />

                    <span>Review Project</span>
                  </NavLink>
                </li>
              ) : (
                ""
              )} */}

              {tl === "false" ? (
                <li className="nav-item border-bottom mb-0 ">
                  <NavLink
                    className={(navData) =>
                      navData.isActive ? "nav-link active_side" : "nav-link"
                    }
                    to="/reviews"
                  >
                    <MdOutlinePreview />

                    <span>Review On Your Code</span>
                  </NavLink>
                </li>
              ) : (
                ""
              )}
            </ul>
          )
        ) : active == "profile" ? (
          <>
            <div className="images_data"></div>

            <ul className="ullistsli ">
              <li className="nav-item border-bottom mb-0 ">
                <NavLink
                  onClick={() => {
                    setActive("profile");
                  }}
                  className={(navData) =>
                    navData.isActive ? "nav-link active_side" : "nav-link"
                  }
                  to="/myprofile"
                >
                  <LiaUserSolid />

                  <span>Profile</span>
                </NavLink>
              </li>
              <li className="nav-item  border-bottom mb-0">
                <NavLink
                  onClick={() => {
                    setActive("profile");
                  }}
                  className={(navData) =>
                    navData.isActive ? "nav-link active_side" : "nav-link"
                  }
                  to="/changepassword"
                >
                  <GoLock />

                  <span>Change Password</span>
                </NavLink>
              </li>
              <li className="nav-item border-bottom mb-0 ">
                <NavLink
                  onClick={() => {
                    Modal.confirm({
                      title: "Confirm Logout",
                      content: "Are you sure you want to logout?",
                      className: "confirm-pop",
                      okText: "Yes",
                      cancelText: "No",
                      onOk: () => {
                        handleLogOut();
                      },
                    });
                  }}
                  className="nav-link"
                >
                  <IoLogOutOutline />

                  <span>Logout</span>
                </NavLink>
              </li>
            </ul>
          </>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default SideBar;
